import jQuery from "jquery";
const $ = jQuery; // ドルマークに参照を代入(慣習的な $ を使うため)

// import Swiper from 'swiper';
import Swiper from 'swiper/bundle'; // import Swiper JS ALL


/*
 * Common
*/

// Single
const postSwiper = new Swiper('.post-swiper', {
  slidesPerView: 1,
  spaceBetween: 30,
  breakpoints: {
    991: {
      slidesPerView: 3,
      spaceBetween: 60,
      // centeredSlides: true, // スライドが中央に表示されるようにする
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 60,
      // centeredSlides: true, // スライドが中央に表示されるようにする
    }
  }
});

// Hero
const heroSwiper = new Swiper('.hero-swiper', {
  loop: true,
  slidesPerView: "auto",
  centeredSlides: true,
  speed: 60000,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
});


/*
 * Single product
 */
$(function() {
  //swiper 768以下で起動
  var swiper;
  $(window).on('load resize', function(){
    var w = $(window).width();
    if (w <= 767.98) {
      if (swiper) {
        return;
      } else {
        swiper = new Swiper('#single-product-gallery', {
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
        });
      }
    } else {
      if (swiper) {
        swiper.destroy();
        swiper = undefined;
      }
    }
  });
});

const SingleProductSubgallerySwiper = new Swiper('#single-product-subgallery', {
  slidesPerView: "auto",
  spaceBetween: 18,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    991: {
      slidesPerView: "auto",
      spaceBetween: 48,
    }
  }
});



// Topics
document.addEventListener("DOMContentLoaded", () => {
  const filterRoot = document.getElementById("topics-filter");

  // 該当セクションがあるページだけ処理を実行
  if (!filterRoot) return;

  const links = filterRoot.querySelectorAll(".category a");
  const topicsList = filterRoot.querySelector("#topics-list");

  function fetchPosts(categoryId = 'all') {
    const url = `/wp-json/custom/v1/posts/?category=${categoryId}`;

    fetch(url)
      .then(response => response.text())
      .then(html => {
        topicsList.innerHTML = html;
      })
      .catch(error => {
        topicsList.innerHTML = '<li><p>読み込みに失敗しました。</p></li>';
        console.error('Fetch error:', error);
      });
  }

  // 初回表示
  fetchPosts();
  links[0]?.classList.add("active");

  // カテゴリリンクのクリック処理
  links.forEach(link => {
    link.addEventListener("click", e => {
      e.preventDefault();

      links.forEach(l => l.classList.remove("active"));
      link.classList.add("active");

      const categoryId = link.dataset.category;
      fetchPosts(categoryId);
    });
  });
});



// wp-block-gallery = Swiper + PhotoSwipe
// Swiper
/*
document.querySelectorAll('.gallery-swiper').forEach(gallery => {
    new Swiper(gallery, {
      slidesPerView: 2, // 横に2枚
      grid: {
        rows: 2, // 縦に2枚
      },
      spaceBetween: 10, // スライド間の余白
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
});
*/
const blockGallerySwiper = new Swiper('.single-customblock-swiper', {
  slidesPerView: 3,  // 1行に3つ (デフォルト設定)
  spaceBetween: 10,   // スライド間の余白
  grid: {
    rows: 2,          // 2行で表示 (デフォルト設定)
    fill: 'row',      // スライドを行ごとに埋める
  },
  slidesPerGroup: 2,   // ページネーションで2グループずつ進める（デフォルト設定）
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  scrollbar: {
    el: ".swiper-scrollbar",
    hide: false,  // 常にスクロールバーを表示
  },
  breakpoints: {
    // 991px以上の画面では
    991: {
      slidesPerView: 3, // 1行に3つ (この設定はデフォルトと同じ)
      grid: {
        rows: 3,  // 2行で表示
      },
      slidesPerGroup: 3,   // 2グループずつ進める
    },
    // 992px以下の画面では
    0: {
      slidesPerView: 3, // 1行に3つ
      grid: {
        rows: 3,  // 3行で表示
      },
      slidesPerGroup: 3,   // 3グループずつ進める
    },
  },
});


/*
// PhotoSwipe
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';

const lightbox = new PhotoSwipeLightbox({
    gallery: '.single-customblock-swiper',
    children: 'a',
    // pswpModule: () => import('https://unpkg.com/photoswipe@5/dist/photoswipe.esm.js')
});
lightbox.init();
*/
